import Button, {ButtonProps} from '@mui/material/Button'
import {styled} from '@mui/material/styles'
import {TransactionType} from '../../../proto/generated/order'
import {blue, red} from '../../../assets/colors'
import {alpha} from '@mui/material'

export type BuySellButtonProps = ButtonProps & {
    transactionType: TransactionType,
    height?: number
}

const BuySellButton = styled(({transactionType, ...props}: BuySellButtonProps) => (
    <Button {...props} />
))(({transactionType, height}) => {
    return transactionType === TransactionType.BUY ? {
        '&.MuiButton-contained': {
            backgroundColor: alpha(blue, 0.8),
            height: height ? `${height}px` : 'auto',
            '&:hover': {
                backgroundColor: blue
            }
        },
        '&.MuiButton-outlined': {
            color: blue
        }
    } : {
        '&.MuiButton-contained': {
            backgroundColor: alpha(red, 0.8),
            height: height ? `${height}px` : 'auto',
            '&:hover': {
                backgroundColor: red
            }
        },
        '&.MuiButton-outlined': {
            color: red
        }
    }
})


export default BuySellButton